import { useState } from "react"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { DashboardCardGroup } from "../../../../dashboards/components/Dashboard"
import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { DashboardDataCard, DashboardDataContents } from "../../../../dashboards/components/DashboardDataCard"
import { makeStyles } from "tss-react/mui"
import { POSPurchasesStat } from "./POSPurchasesStat"
import { POSOrdersStat } from "./POSOrdersStat"
import { MeetingServicesPurchasesStat } from "./MeetingServicesPurchasesStat"
import { MeetingServicesOrdersStat } from "./MeetingServicesOrdersStat"
import { UsersStat } from "./UsersStat"
import { CheckInStat } from "./CheckInStat"
import { useNavigate } from "react-router"
import { COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE, COMPANY_ACCOUNTING_POS_ROUTE } from "../../../../../constants/routes"
import { useMatchEnvironment } from "../../../../environment/envHooks"
import { UNFINISHED_FEATURE_ENVIRONMENTS } from "../../../../../shared/components/filters/constants/filterMenuConst"

const useStyles = makeStyles()(() => ({
    select: {
        "&:after, &:before": {
            display: "none",
        },
    },
    customSpacer: {
        height: "0",
    },
}))

export function PurchaseSection() {
    const navigate = useNavigate()
    // the accounting pages are hidden from the nav outside the unfinished-feature environments (endpoints not live),
    // so the cards must not lead there either
    const canOpenAccountingPages = useMatchEnvironment(UNFINISHED_FEATURE_ENVIRONMENTS)
    const openPage = (route: string) => (canOpenAccountingPages ? () => navigate(route) : undefined)
    const { classes } = useStyles()
    const periods = [3, 14, 30, 60, 180]

    const [periodInDays, setPeriodInDays] = useState<number>(30)

    const handlePeriodChange = (event: SelectChangeEvent<number>) => {
        setPeriodInDays(Number(event.target.value))
    }

    return (
        <LocalizedStrict id="company-home-purchases-card-group" attrs={{ title: true }}>
            <DashboardCardGroup
                title="Purchases"
                titleRightContent={
                    <FormControl variant="standard" size="small">
                        <Select value={periodInDays} onChange={handlePeriodChange} className={classes.select}>
                            {periods.map((option) => (
                                <MenuItem key={option} value={option}>
                                    <LocalizedEnum
                                        base="company-home-purchases-period-base"
                                        enumValue={option.toString()}
                                    >
                                        <>{option}</>
                                    </LocalizedEnum>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            >
                <LocalizedStrict id="company-home-purchases-pos-purchases-title" attrs={{ title: true }}>
                    <DashboardDataCard title="POS purchases" onClick={openPage(COMPANY_ACCOUNTING_POS_ROUTE)}>
                        <DashboardDataContents>
                            <POSPurchasesStat periodInDays={periodInDays} />
                        </DashboardDataContents>
                    </DashboardDataCard>
                </LocalizedStrict>
                <LocalizedStrict id="company-home-purchases-pos-orders-title" attrs={{ title: true }}>
                    <DashboardDataCard title="POS orders" onClick={openPage(COMPANY_ACCOUNTING_POS_ROUTE)}>
                        <DashboardDataContents>
                            <POSOrdersStat periodInDays={periodInDays} />
                        </DashboardDataContents>
                    </DashboardDataCard>
                </LocalizedStrict>
                <LocalizedStrict id="company-home-purchases-meeting-service-purchases-title" attrs={{ title: true }}>
                    <DashboardDataCard
                        slotProps={{ spacer: { className: classes.customSpacer } }}
                        title="Meeting service purchases"
                        onClick={openPage(COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE)}
                    >
                        <DashboardDataContents>
                            <MeetingServicesPurchasesStat periodInDays={periodInDays} />
                        </DashboardDataContents>
                    </DashboardDataCard>
                </LocalizedStrict>
                <LocalizedStrict id="company-home-purchases-meeting-service-orders-title" attrs={{ title: true }}>
                    <DashboardDataCard
                        slotProps={{ spacer: { className: classes.customSpacer } }}
                        title="Meeting service orders"
                        onClick={openPage(COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE)}
                    >
                        <DashboardDataContents>
                            <MeetingServicesOrdersStat periodInDays={periodInDays} />
                        </DashboardDataContents>
                    </DashboardDataCard>
                </LocalizedStrict>
                <LocalizedStrict id="company-home-purchases-users-title" attrs={{ title: true }}>
                    <DashboardDataCard title="Users" onClick={() => {}}>
                        <DashboardDataContents>
                            <UsersStat periodInDays={periodInDays} />
                        </DashboardDataContents>
                    </DashboardDataCard>
                </LocalizedStrict>
                <LocalizedStrict id="company-home-purchases-check-in-title" attrs={{ title: true }}>
                    <DashboardDataCard title="Check-ins" onClick={() => {}}>
                        <DashboardDataContents>
                            <CheckInStat periodInDays={periodInDays} />
                        </DashboardDataContents>
                    </DashboardDataCard>
                </LocalizedStrict>
            </DashboardCardGroup>
        </LocalizedStrict>
    )
}
